export default {
      id: "view-usage",
      viewBox: "0 0 16 17",
      url: __webpack_public_path__ + "sprite.svg#view",
      toString: function () {
        return this.url;
      }
    }